import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  getCurrentPredictionStep,
  getPredictionRunningState,
} from "../../../store/selectors/PredictionSelectors";
import FileUpload from "../../../components/FileUpload";
import { uploadLocatorAction } from "../../../store/actions/LocatorsActions";
import { getLocatorUploadStatus } from "../../../store/selectors/LocatorSelectors";
import { resetLocatorUpload } from "../../../store/reducers/LocatorsReducers";
import {
  resetPredictionSlice,
  updatePredictionStep,
} from "../../../store/reducers/PredictionReducers";
import PredictionOverview from "../../../components/Model/PredictionOverview";
import ViewPredictionResultsLocators from "../../../components/Model/ViewPredictionResultsLocators";

const LocatorModel = () => {
  const dispatch = useAppDispatch();
  const predictionStep = useAppSelector(getCurrentPredictionStep);
  const locatorUploadStatus = useAppSelector(getLocatorUploadStatus);
  const predictionRunningState = useAppSelector(getPredictionRunningState);

  const [selectedFile, setSelectedFile] = useState<any>(null);

  useEffect(() => {
    return function () {
      setSelectedFile(null);
      dispatch(resetPredictionSlice());
      dispatch(resetLocatorUpload());
      setSelectedFile(null);
    };
  }, [dispatch]);

  const handleFileSubmission = useCallback(() => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("image", selectedFile, selectedFile.name);
    dispatch(uploadLocatorAction(formData));
  }, [selectedFile, dispatch]);

  const fileUploadProps = useCallback(
    () => ({
      isFileUploading: locatorUploadStatus === "loading",
      selectedFile,
      showCancel: false,
      onFileChange: setSelectedFile,
      onCancelUpload: () => console.log("soon"),
      handleFileSubmission,
      modelType: "locator",
      allowMultiple: false, // Predictions should only allow single files
    }),
    [selectedFile, locatorUploadStatus, handleFileSubmission]
  );

  useEffect(() => {
    if (locatorUploadStatus === "idle") {
      setSelectedFile(null);
      dispatch(updatePredictionStep(1));
      return;
    }

    if (locatorUploadStatus !== "success") return;
    dispatch(updatePredictionStep(2));
  }, [locatorUploadStatus, dispatch]);

  useEffect(() => {
    if (predictionRunningState === "error" && selectedFile !== null)
      setSelectedFile(null);
  }, [selectedFile, predictionRunningState]);

  const modelContent = useCallback(() => {
    switch (predictionStep) {
      case 1:
        return <FileUpload {...fileUploadProps()} />;
      case 2:
        return <PredictionOverview />;
      case 3:
        return <ViewPredictionResultsLocators />;
      default:
        return <p>soon</p>;
    }
  }, [predictionStep, fileUploadProps]);

  return modelContent();
};

export default LocatorModel;
